
import { Vue, Component, Prop } from "vue-property-decorator";

import Button from "./Button.vue";
import Menu from "./Menu.vue";

interface AuthValue {
  user: any;
  loggedIn: boolean;
  logout(): any;
}
@Component({
  components: { Button, Menu },
})
export default class UserMenu extends Vue {
  @Prop() readonly auth!: AuthValue;
  @Prop({ default: true }) readonly localeSwitcher!: boolean;

  showMenu = false;

  mounted(): void {
    // Close dropdown menu when clicking outside
    document.body.addEventListener("mousedown", (event: MouseEvent): void => {
      if (event.target) {
        const element = event.target as HTMLElement;
        if (!(element.closest && element.closest("[data-dropdown]"))) {
          this.showMenu = false;
        }
      }
    });
  }

  replaceAvatarByDefault(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = "/img/avatar.png";
  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }
}
